import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    InputSignal,
    OutputEmitterRef,
    ViewEncapsulation,
    input,
    output,
} from "@angular/core";

import { IconButtonComponent } from "@core/components/icon-button/icon-button.component";
import { RutsBlockDirective } from "@core/directives/bem/block.directive";
import { RutsElemDirective } from "@core/directives/bem/elem.directive";
import { ENotificationBannerTheme } from "@core/enums/notification.enum";

const BEM_BLOCK: string = "cc-notification-banner";

@Component({
    standalone: true,
    selector: "cc-notification-banner",
    templateUrl: "./notification-banner.component.html",
    styleUrls: ["./notification-banner.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [
        // BEM
        RutsBlockDirective,
        RutsElemDirective,

        // standalone components
        IconButtonComponent,
    ],
})
export class NotificationBannerComponent {
    protected readonly Theme: typeof ENotificationBannerTheme = ENotificationBannerTheme;

    public readonly text: InputSignal<string> = input.required<string>();
    public readonly theme: InputSignal<ENotificationBannerTheme> = input<ENotificationBannerTheme>(
        ENotificationBannerTheme.Alert
    );
    public readonly closeLabel: InputSignal<string> = input<string>("закрыть");
    public readonly closeEvent: OutputEmitterRef<void> = output<void>();

    @HostBinding("class")
    public get hostClasses(): Record<string, boolean> {
        return {
            [BEM_BLOCK]: true,
            [`${BEM_BLOCK}--${this.theme()}`]: true,
        };
    }

    protected onClose(): void {
        this.closeEvent.emit();
    }
}
